import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {


  url = environment.serverAPI9 + "/api";


  constructor(private http: HttpClient) { }

  newTemplates(templates: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/crmTemplates`, templates)
  }

  templates(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}/crmTemplates?page=${Page}&size=${size}&sort=${sort}`);
  }

  templatesSearch(query: any, Page: any, size: any, sort: any): Observable<Object> {

    return this.http.get(`${this.url}/crmTemplates/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }


  getAllTemplatesDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/crmTemplates/dropdown`);
  }
}

